import React from 'react';

export const SupportPage: React.FC = () => {
  return (
    <div className="bg-slate-50 min-h-screen font-sans flex flex-col">
      <nav className="bg-white border-b border-slate-100 px-6 py-4 sticky top-0 z-10 flex-none">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
            <div className="flex items-center gap-2">
                <img 
                    src="https://image2url.com/r2/default/images/1769369928623-3180bbac-a140-4e50-ac88-1cfcf218a72a.png" 
                    alt="LoveOnRead Logo" 
                    className="w-8 h-8 object-contain"
                />
                <span className="font-bold text-xl tracking-tight">
                    <span className="text-love">Love</span>
                    <span className="text-read">OnRead</span>
                </span>
            </div>
            <a href="/" className="text-sm font-medium text-slate-600 hover:text-slate-900">
                Home
            </a>
        </div>
      </nav>

      <main className="flex-1 w-full max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-extrabold text-slate-900 mb-6">App Support</h1>
        
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100">
            <h2 className="text-xl font-bold text-slate-800 mb-4">How can we help?</h2>
            <p className="text-slate-600 mb-8 text-sm leading-relaxed">
                If you are experiencing issues with the LoveOnRead mobile app, subscriptions, or have feature requests, please reach out to us directly.
            </p>

            <div className="space-y-8">
                <div className="p-6 bg-brand-50 rounded-xl border border-brand-100">
                    <h3 className="font-bold text-slate-900 mb-2">Contact Support Team</h3>
                    <p className="text-sm text-slate-600 mb-4">
                        Our team typically responds within 24-48 hours.
                    </p>
                    <a 
                        href="mailto:loveonreadai@gmail.com" 
                        className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-sm font-bold rounded-xl text-white bg-brand-600 hover:bg-brand-700 transition-colors shadow-lg shadow-brand-500/30"
                    >
                        Email: loveonreadai@gmail.com
                    </a>
                </div>

                <div className="border-t border-slate-100 pt-8">
                    <h3 className="font-bold text-slate-900 mb-6 text-lg">Common Questions</h3>
                    <ul className="space-y-6">
                        <li className="flex gap-4 items-start text-sm text-slate-600">
                            <span className="flex-shrink-0 w-6 h-6 bg-slate-100 rounded-full flex items-center justify-center text-slate-500 font-bold text-xs mt-0.5">?</span>
                            <div>
                                <strong className="block text-slate-900 mb-1 text-base">How do I cancel my subscription?</strong>
                                <p><strong>iOS:</strong> Go to your iPhone Settings &gt; Apple ID &gt; Subscriptions &gt; LoveOnRead.</p>
                                <p className="mt-1"><strong>Android:</strong> Open Google Play Store &gt; Profile Icon &gt; Payments & subscriptions &gt; Subscriptions &gt; LoveOnRead.</p>
                            </div>
                        </li>
                        <li className="flex gap-4 items-start text-sm text-slate-600">
                            <span className="flex-shrink-0 w-6 h-6 bg-slate-100 rounded-full flex items-center justify-center text-slate-500 font-bold text-xs mt-0.5">?</span>
                            <div>
                                <strong className="block text-slate-900 mb-1 text-base">How do I delete my account?</strong>
                                Open the mobile app, go to Profile &gt; Settings &gt; Delete Account. This will permanently remove your chat history and profile data from our servers.
                            </div>
                        </li>
                         <li className="flex gap-4 items-start text-sm text-slate-600">
                            <span className="flex-shrink-0 w-6 h-6 bg-slate-100 rounded-full flex items-center justify-center text-slate-500 font-bold text-xs mt-0.5">?</span>
                            <div>
                                <strong className="block text-slate-900 mb-1 text-base">Request a Refund</strong>
                                <p>Since payments for the mobile app are handled by Apple or Google directly, we cannot process refunds on our end.</p>
                                <ul className="list-disc pl-4 mt-2 space-y-1">
                                    <li><strong>iOS:</strong> Visit <a href="https://reportaproblem.apple.com" target="_blank" rel="noreferrer" className="text-brand-600 underline">reportaproblem.apple.com</a></li>
                                    <li><strong>Android:</strong> Visit <a href="https://support.google.com/googleplay/workflow/9813244" target="_blank" rel="noreferrer" className="text-brand-600 underline">Google Play Refund Request</a></li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
      </main>
      
      <footer className="py-8 text-center text-slate-400 text-xs border-t border-slate-100 bg-white">
        &copy; {new Date().getFullYear()} LoveOnRead. All rights reserved.
      </footer>
    </div>
  );
};